import { Suggestion } from '@displate/styleguide/dist/hydra/modules/Autocomplete/components/types';

import { PhraseAutocomplete } from 'generatedBfw/static/models/PhraseAutocomplete';

export const mapSuggestions = (
  phraseAutocomplete: PhraseAutocomplete | undefined,
): Suggestion[] | undefined => {
  return phraseAutocomplete?.phrases.map<Suggestion>((x) => {
    return { phrase: x.phrase, categories: x.categories };
  });
};
